import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DeleteButton,
    TopToolbar,
    useNotify,
    useDataProvider,
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField as MuiTextField } from '@mui/material';
import { useState } from 'react';

// Toolbar with a create button
const NotificationListActions = ({ setOpen }) => (
    <TopToolbar>
        <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
            Create Notification
        </Button>
    </TopToolbar>
);

// Main component for listing, creating, and deleting notifications
const NotificationList = () => {
    const notify = useNotify(); // Fix: Initialize notify
    const dataProvider = useDataProvider(); // Fix: Initialize dataProvider
    const [open, setOpen] = useState(false);

    // State to handle form data for creation
    const [formData, setFormData] = useState({ title: '', message: '' });

    // Handle input change in the form
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission for creating a new notification
    const handleSubmit = async () => {
        try {
            await dataProvider.create('notifications', { data: formData });
            notify('Notification sent successfully'); // Fix: Use notify
            setFormData({ title: '', message: '' }); // Reset form
            setOpen(false); // Close the dialog
        } catch (error) {
            notify(`Error: ${error.message}`, { type: 'warning' }); // Fix: Use notify
        }
    };

    return (
        <>
            {/* Always-visible Create Notification Button */}
            <NotificationListActions setOpen={setOpen} />

            {/* List of notifications */}
            <List title="Notifications" empty={<div>No notifications found</div>}>
                <Datagrid>
                    <TextField source="id" label="ID" />
                    <TextField source="title" label="Title" />
                    <TextField source="body" label="Message" />
                    <TextField source="create_date_time" label="Created Date/Time" />
                    <DeleteButton
                        label="Delete"
                        redirect={false}
                        onSuccess={() => notify('Notification deleted successfully')} // Fix: Use notify
                        onFailure={(error) => notify(`Error: ${error.message}`, { type: 'warning' })} // Fix: Use notify
                    />
                </Datagrid>
            </List>

            {/* Create Notification Dialog */}
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Create Notification</DialogTitle>
                <DialogContent>
                    <MuiTextField
                        label="Title"
                        value={formData.title}
                        name="title"
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />
                    <MuiTextField
                        label="Message"
                        value={formData.message}
                        name="message"
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        multiline
                        rows={6}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default NotificationList;
